module.exports = __webpack_public_path__ + "img/customer-bg.68460ee6.png";